import axios from 'axios';
import {backendHost} from '../../config';

export const getBrandsById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/brands/${params.id}`);
};